/* Reconocimiento de voz del navegador (Chrome en Android): hablas y sale como texto. Usa el servicio de voz de
   Google, así que NECESITA RED (sin conexión no funciona, y no hay forma de evitarlo desde una web). */
type Idioma = 'es-ES' | 'ja-JP';
interface Reconocedor {
  lang: string; interimResults: boolean; maxAlternatives: number; continuous: boolean;
  start(): void; stop(): void; abort(): void;
  onresult: ((e: { results: ArrayLike<ArrayLike<{ transcript: string }>> }) => void) | null;
  onerror: ((e: { error: string }) => void) | null;
  onend: (() => void) | null;
}
type Fabrica = new () => Reconocedor;

const fabrica = (): Fabrica | undefined => {
  const w = window as unknown as { SpeechRecognition?: Fabrica; webkitSpeechRecognition?: Fabrica };
  return w.SpeechRecognition ?? w.webkitSpeechRecognition;
};
export const hayVoz = () => !!fabrica();

const MENSAJES: Record<string, string> = {
  'not-allowed': 'Sin permiso para el micrófono: actívalo para Tabiji en el navegador.',
  'service-not-allowed': 'Sin permiso para el micrófono: actívalo para Tabiji en el navegador.',
  'no-speech': 'No te he oído. Acércate al micrófono y vuelve a intentarlo.',
  'audio-capture': 'No encuentro el micrófono.',
  network: 'Sin conexión: el reconocimiento de voz necesita red.',
  'language-not-supported': 'Este móvil no entiende ese idioma por voz.',
};

/** Escucha una frase en ese idioma. `parar()` la corta (y devuelve lo que hubiera entendido, si algo). */
export function escuchar(idioma: Idioma): { texto: Promise<string>; parar: () => void } {
  const R = fabrica();
  if (!R) return { texto: Promise.reject(new Error('Este navegador no tiene reconocimiento de voz (en Android, usa Chrome).')), parar: () => {} };
  const r = new R();
  r.lang = idioma; r.interimResults = false; r.maxAlternatives = 1; r.continuous = false;
  const texto = new Promise<string>((ok, mal) => {
    let dicho = '';
    r.onresult = e => { dicho = Array.from(e.results).map(x => x[0].transcript).join(' ').trim(); };
    r.onerror = e => mal(new Error(MENSAJES[e.error] ?? `No se pudo escuchar (${e.error}).`));
    r.onend = () => (dicho ? ok(dicho) : mal(new Error(MENSAJES['no-speech'])));
    try { r.start(); } catch { mal(new Error('No se pudo empezar a escuchar.')); }
  });
  return { texto, parar: () => { try { r.stop(); } catch { /* ya parado */ } } };
}
